import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

// Get environment variables with fallbacks for development
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://exnabgznlqdignkqljbd.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV4bmFiZ3pubHFkaWdua3FsamJkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2NTgyMjUsImV4cCI6MjA2MzIzNDIyNX0.kUkOgUHkc1FsHVAsS3ElLi_msakoX0IEA6Qf4qMOWzo';

// In development, warn if environment variables are missing
if (import.meta.env.DEV && (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY)) {
  console.warn('⚠️ Missing Supabase environment variables. Using fallback values for development.');
}

// Create and export the Supabase client
let supabaseClient: ReturnType<typeof createClient<Database>> | null = null;

try {
  supabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey);
} catch (error) {
  console.error('Failed to initialize Supabase client:', error);
  // Initialize with dummy client that will be handled gracefully in the app
}

export const supabase = supabaseClient as ReturnType<typeof createClient<Database>>;

// Helper function to bypass RLS for admin operations by getting service role client
// IMPORTANT: Only use this in server-side code or admin-protected routes
export const getServiceClient = (serviceRoleKey?: string) => {
  // Avoid creating service client if no key is provided
  if (!serviceRoleKey) {
    console.error('No service role key provided to getServiceClient');
    return null;
  }
  
  try {
    return createClient<Database>(supabaseUrl, serviceRoleKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    });
  } catch (error) {
    console.error('Failed to create service client:', error);
    return null;
  }
};